import React from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';
import PdfTableColumn from './PdfTableColumn';

const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        backgroundColor: "#248EDB",
        margin: 2
    },
    col: {
        color: "#ffffff",
        fontSize: "12",
        borderStyle: "solid",
        textAlign: "left"
    }
});

const PdfTableHeaderRow = ({data}) => {
    return (
        <View style={styles.row} key={data.key.toString()}>
            {data.cols.map((column) => {
                return (
                    <PdfTableColumn style={[styles.col, column.style]} key={data.key.toString()+"-"+column.key.toString()+"-col"} data={column}/>
                )
            })}
        </View>
    )
};

export default PdfTableHeaderRow
